/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { useRef, useState } from 'react';
import {
  ComposedChart,
  //   Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Brush,
  Line,
} from 'recharts';
import html2canvas from 'html2canvas';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Button,
} from '@mui/material';
import Swal from 'sweetalert2';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import LoadingOverlay from '../components/LoadingOverlay';

const TrendsCertGraph = ({ certiGraph, loading }) => {
  const [loading1, setLoading1] = useState(false);
  const chartRef = useRef(null); // Reference to the container to be captured
  const updatedGraphData = certiGraph.map((item) => ({
    SKU: item.SKU,
    ScrapCount: parseInt(item.ScrapCount, 10),
    PackCount: parseInt(item.PackCount, 10),
    ProductionPlan: parseInt(item.ProductionPlan, 10),
    // AvgByDay: parseFloat(item.AvgByDay),
  }));

  const downloadChart = async () => {
    setLoading1(true); // Set loading to true
    const chartElement = chartRef.current; // The chart's container
    if (chartElement) {
      // Scroll to the chart if it's off-screen
      chartElement.scrollIntoView({ behavior: 'smooth' });
      try {
        // Wait for the canvas to be created
        const canvas = await html2canvas(chartElement);
        // Proceed with download
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'CertifiedTrends.png'; // File name for download
        link.click();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Error capturing the chart:',
          error,
        });
      } finally {
        // Set loading to false after the download is completed
        setLoading1(false);
      }
    } else {
      setLoading1(false);
    }
  };
  // FOR LEGEND CUSTUMISATION AND OTHER STYLING OF SAME
  const renderCustomLegend = (props) => {
    const { payload } = props;
    return (
      <ul style={{ display: 'flex', listStyle: 'none', padding: 0, justifyContent: 'center' }}>
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: 10,
              color: entry.color, // Keep the color from payload
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 32 32"
              style={{ marginRight: 4 }}
            >
              <rect fill={entry.color} width="32" height="32" />
            </svg>
            {entry.value === 'PackCount'
              ? 'Pack' : entry.value === 'ScrapCount' ? 'Scrap' : entry.value === 'ProductionPlan' ? 'Production Plan'
                : `${entry.value}`}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: -3, mb: 1 }}>
        <Typography
          variant="h5"
          sx={{
            margin: '10px 0 0 20px',
            backgroundColor: '#FBF6E9',
            borderRadius: '8px',
            padding: '4px 12px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        >
          Certified Trends
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadChart}
          disabled={loading1}
          startIcon={loading1 && <CircularProgress size={20} color="inherit" />}
          sx={{ zIndex: 10, margin: '0 40px -30px 0' }}
          endIcon={<LeaderboardIcon />}
        >
          {loading1 ? 'Downloading...' : 'Download'}
        </Button>
      </Box>
      <Paper id="trendGraph_id">
        {loading ? (
          <LoadingOverlay />
        ) : updatedGraphData.length !== 0 ? (
          <ResponsiveContainer width="100%" height="99%" ref={chartRef}>
            <ComposedChart
              data={updatedGraphData}
              margin={{
                top: 40,
                right: 10,
                bottom: 5,
                left: 10,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis
                angle={updatedGraphData.length > 15 ? 25 : 0}
                dataKey="SKU"
                tick={{ fontSize: updatedGraphData.length > 15 ? 12 : 14, dy: 10 }}
                // interval={0} // show all labels
                height={50}
                label={{
                  value: 'SKU',
                  position: 'insideBottom', // or "bottom"
                  offset: 10, // Push down so it comes after Brush
                  style: { fontSize: 14, fontWeight: 'bold', marginTop: '40px' },
                }}
              />
              <YAxis
                yAxisId="left"
                orientation="left"
                label={{
                  value: 'Pack & Scrap Quantity',
                  angle: -90,
                  position: 'insideLeft',
                  style: { fontWeight: 'bold' },
                }}
              />
              {/* <YAxis yAxisId="right" orientation="right">
                <Label
                  value="Production Plan"
                  angle={-90}
                  position="insideRight"
                  offset={10}
                  style={{ fontWeight: 'bold' }}
                />
              </YAxis> */}
              <Tooltip />
              <Legend content={renderCustomLegend} />
              <Bar
                yAxisId="left"
                dataKey="PackCount"
                barSize={40}
                fill="#A294F9"
                label={({ x, y, width, value }) => (
                  <text
                    x={x + width / 2} // Centers the label horizontally
                    y={y - 10} // Adjusts the vertical position above the bar
                    fill="#A294F9" // Text color
                    textAnchor="middle" // Centers the text
                    fontSize={14} // Adjust the font size
                    fontWeight="bold"
                  >
                    {value}
                  </text>
                )}
              />
              <Bar
                yAxisId="left"
                dataKey="ScrapCount"
                barSize={40}
                fill="#F72C5B"
                label={({ x, y, width, value }) => (
                  <text
                    x={x + width / 2} // Centers the label horizontally
                    y={y - 10} // Adjusts the vertical position above the bar
                    fill="#F72C5B" // Text color
                    textAnchor="middle" // Centers the text
                    fontSize={14} // Adjust the font size
                    fontWeight="bold"
                  >
                    {value}
                  </text>
                )}
              />

              <Line
                yAxisId="left"
                type="monotone"
                dataKey="ProductionPlan"
                stroke="#543A14"
                strokeWidth={2}
                label={({ x, y, value }) => (
                  <text
                    x={x}
                    y={y - 20}
                    fill="#543A14"
                    fontSize={16}
                    fontStyle="italic"
                    fontWeight="bold"
                  >
                    {value}
                  </text>
                )}
              />
              <Brush
                dataKey="SKU"
                height={30}
                stroke="#C4D9FF"
                y={undefined}
              />

            </ComposedChart>
          </ResponsiveContainer>
        ) : (
          <Typography
            variant="h6"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            No Data available!
          </Typography>
        )}
      </Paper>
    </>
  );
};

export default TrendsCertGraph;
